import { Controller } from "@hotwired/stimulus"

export default class ResendCodeController extends Controller {
  static targets = ["link"]

  connect() {
    this.originalText = this.linkTarget.innerText
    this.startCountdown(30)
  }

  disable(event) {
    if (this.disabled) {
      event.preventDefault()
      return
    }

    this.startCountdown(30)
  }

  startCountdown(seconds) {
    this.disabled = true
    this.remaining = seconds

    this.linkTarget.classList.add("disabled")
    this.linkTarget.style.pointerEvents = "none"

    this.linkTarget.innerText = `Resend in ${this.remaining}s`

    clearInterval(this.interval)
    this.interval = setInterval(() => {
      this.remaining--

      if (this.remaining > 0) {
        this.linkTarget.innerText = `Resend in ${this.remaining}s`
      } else {
        clearInterval(this.interval)
        this.enableLink()
      }
    }, 1000)
  }

  enableLink() {
    this.disabled = false
    this.linkTarget.classList.remove("disabled")
    this.linkTarget.style.pointerEvents = "auto"

    this.linkTarget.innerText = this.originalText
  }
}
